import Logo, { LogoImg } from './Logo';

export { Logo as default, LogoImg };
